module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/th_6-8c89a18476f1a34fe19a8b6f8c5aa33b.jpg";